'use strict';
define('elements/colorbox',['utils/domready', 'jquery','jquery-colorbox'], function(domready, $, Colorbox) {
    domready(function() {
        var $colorboxTrigger = $("a.colorbox"),
            $groupedTrigger = $("a[data-modal]");

        $colorboxTrigger.colorbox({
            rel: function() {
                return $(this).data('modal')
            },
            maxWidth: '80%',
            maxHeight: '80%',
            fixed: true,
            scrolling: false,
            previous: "",
            next: "",
            close: ""
        });

        $groupedTrigger.colorbox({
            maxWidth: '80%',
            maxHeight: '80%',
            initialWidth: '40%',
            initialHeight: '40%',
            fixed: true,
            scrolling: false,
            previous: '',
            next: '',
            close: ''
        });
    });
});

